import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import { Ets2AffidavitFullDTO } from "../dtos/Ets2AffidavitFullDTO";
import { useTranslation } from "react-i18next";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import { formatDate } from "features/shared/helpers/Formatters";
import IFileService from "data/IFileService";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import LinkButton from "features/shared/components/buttons/LinkButton";

interface Props {
  affidavit: Ets2AffidavitFullDTO;
}

const Ets2AffidavitInfoCard = ({ affidavit }: Props) => {
  // translations
  const tLabels = useTranslation("ets2\\ets2").t;
  const tStatus = useTranslation(["ets2\\enums\\ets2AffidavitStatus"]).t;

  const fileService = useInjection<IFileService>(IocTypes.FileService);

  const handleDownload = () => {
    if (!affidavit.document) return;
    fileService.downloadDocument(affidavit.document);
  };


  // render
  return (
    <PageCard title={tLabels("ets2AffidavitInfoCard.title")}>    
      <div className="row g-3">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("ets2AffidavitInfoCard.affidavitNumber")}
            value={affidavit.affidavitNumber || "—"}
            icon="tasks"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("ets2AffidavitInfoCard.ets2AffidavitStatus")}
            value={
              affidavit.ets2AffidavitStatus
                ? tStatus(affidavit.ets2AffidavitStatus)
                : "—"
            }
            icon="tag"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("ets2AffidavitInfoCard.year")}
            value={(affidavit.year ?? "—") as any}
            icon="calendar-check"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("ets2AffidavitInfoCard.createdDate")}
            value={
              affidavit.createdDate
                ? formatDate(affidavit.createdDate!)
                : "—"
            }
            icon="calendar-alt"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("ets2AffidavitInfoCard.powerOfAttorney")}
            value={affidavit.document ? (<LinkButton text={tLabels("ets2AffidavitInfoCard.download")} onClick={handleDownload}/>) : ("—")}
            icon="download"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("ets2AffidavitInfoCard.businessTypeName")}
            value={affidavit.businessTypeName || "—"}
            icon="briefcase"
          />
        </div>
        <div className="col-12 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("ets2AffidavitInfoCard.consumptionTypeName")}
            value={affidavit.consumptionTypeName || "—"}
            icon="fire"
          />
        </div>
      </div>
    </PageCard>
  );
};

export default Ets2AffidavitInfoCard;
